module.exports = __webpack_public_path__ + "static/media/meylani.4b97d71e.jpg";